import { configureStore } from "@reduxjs/toolkit";

import mainReducer from "components/layouts/MainLayout/slices/mainSlice";
import yearAccumulateSlice from "features/accumulate/slices/yearAccumulateSlice";
import attendanceReducer from "features/attendance/slices/attendanceSlice";
import loginReducer from "features/authentication/slices/loginSlice";
import passwordReducer from "features/authentication/slices/passwordSlice";
import signUpReducer from "features/authentication/slices/signUpSlice";
import companyReducer from "features/company/slices/companySlice";
import configMailReducer from "features/company/slices/configMailSlice";
import configReducer from "features/config/slices/configSlice";
import employeeReducer from "features/employee/slices/employeeSlice";
import masterDataReducer from "features/masterData/slices/masterDataSlice";
import optionsReducer from "features/masterData/slices/optionsSlice";
import myDocumentReducer from "features/myDocument/slices/myDocumentSlice";
import newsReducer from "features/newAndPolicy/slices/newsSlice";
import policyReducer from "features/newAndPolicy/slices/policySlice";
import payrollReducer from "features/payroll/slices/payrollSlice";
import requestApprovalReducer from "features/requestApproval/slices/requestApprovalSlice";
import socialSecurityContributionSlice from "features/socialSecurityContribution/slices/socialSecurityContributionSlice";
import userReducer from "features/userManagement/slices/userSlice";

import accountCategorySlice from "features/accountCategory/slices/accountCategorySlice";
import homeReducer from "features/home/slices/homeSlice";

import dashboardSlice from "features/dashboard/slices/dashboardSlice";
import salarySlice, { SALARY_SLICE } from "features/employee/slices/salarySlice";
import { HOME_SLICE } from "features/home/slices/homeSlice";
import settingMailNotiSlice, { SETTING_MAIL_NOTI } from "features/settingEemailNotification/slices/settingMailNotiSlice";
import settingEmailTemplateReducer, { SETTING_EMAIL_TEMPLATE } from "features/settingEmailTemplate/slices/settingEmailTemplateSlice";
import emailLoopReducer, { EMAIL_LOOP } from "features/emailLoop/slices/emailLoopSlice";
import templateSlice from "./features/createTemplate/slices/templateSlice";
import socialSecuritySlice from "features/employee/slices/socialSecuritySlice";
import holidaySlice from "features/attendance/slices/holidaySlice";
import ExpenseSlices from "features/Expense/slices/ExpenseSlices";
import myteamSlice, { MY_TEAM } from "features/myTeam/slices/myteamSlice";
import webappSlice from "features/webapp/slices/webappSlice";
import whiteListSlice from "features/whiteList/slices/whiteListSlice";
import PaymentSlices from "features/payment/slices/PaymentSlices";
import reportSlice from "features/Report/slices/reportSlice";
import workFlowSlice from "features/attendance/slices/workFlowSlice";
import productManagementSlice from "features/product/slices/productManagementSlice";
import timeSheetRoleSlice from "features/settingTimesheet/slices/TimeSheetRoleSlice.js"
import timeSheetMasterDataSlice from "features/settingTimesheet/slices/TimeSheetMasterDataSlice.js"
import timeSheetSlice from "features/settingTimesheet/slices/TimeSheetSlice"
import myTimesheetSlices from "features/myTimesheet/slices/myTimesheetSlice"
import adminCompanySlice from "features/adminCompany/slices/adminCompanySlice"
import welfareSlice from "features/payrollSetting/slices/welfareSlice";
import adminPermissionSlice from "features/adminPermission/slices/adminPermissionSlice"
import fundReducer from "features/fund/slices/fundSlice";
import notificationReducer, { NOTIFICATION } from "features/notification/slices/notificationSlice";
export const store = configureStore({
  reducer: {
    attendance: attendanceReducer,
    login: loginReducer,
    signUp: signUpReducer,
    password: passwordReducer,
    company: companyReducer,
    configMail: configMailReducer,
    employee: employeeReducer,
    options: optionsReducer,
    payroll: payrollReducer,
    fund: fundReducer,
    masterData: masterDataReducer,
    myDocument: myDocumentReducer,
    news: newsReducer,
    config: configReducer,
    policy: policyReducer,
    user: userReducer,
    main: mainReducer,
    requestApproval: requestApprovalReducer,
    socialSecurityContribution: socialSecurityContributionSlice,
    yearAccumulate: yearAccumulateSlice,
    [HOME_SLICE]: homeReducer,
    accountCategory: accountCategorySlice,
    [SETTING_MAIL_NOTI]: settingMailNotiSlice,
    template: templateSlice,
    dashboard: dashboardSlice,
    [SALARY_SLICE]: salarySlice,
    [MY_TEAM]: myteamSlice,
    socialSecurity: socialSecuritySlice,
    holidayCalendar: holidaySlice,
    expense: ExpenseSlices,
    webapp: webappSlice,
    whitelist: whiteListSlice,
    payment: PaymentSlices,
    report: reportSlice,
    workFlow: workFlowSlice,
    productManagement: productManagementSlice,
    timeSheetRole: timeSheetRoleSlice,
    timeSheetMasterData: timeSheetMasterDataSlice,
    timeSheet: timeSheetSlice,
    myTimesheet: myTimesheetSlices,
    adminCompany: adminCompanySlice,
    welfare: welfareSlice,
    adminPermission: adminPermissionSlice,
    [SETTING_EMAIL_TEMPLATE]: settingEmailTemplateReducer,
    [EMAIL_LOOP]: emailLoopReducer,
    [NOTIFICATION]: notificationReducer,
  },
});
